import React from 'react';
import { Grid } from '@material-ui/core';

import { ShortBody } from 'components/Typography';
import { SizedCaptions } from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/MyguaranteesBloc/style';
const TabPanelContentWithoutVideo = ({ title, body, ...otherProps }: any) => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ShortBody weight="bold" color="#0075C9">
            {title}
          </ShortBody>
        </Grid>
        <Grid item xs>
          <SizedCaptions weight="400">{body}</SizedCaptions>
        </Grid>
      </Grid>
    </>
  );
};

export default TabPanelContentWithoutVideo;
